<template>
    <div class="card-wrapper">
        <v-card class="ma-2 elevation-3">
            <div class="offset-header">
                <v-card color="primary" class="header-card border-r-5 card-header">
                    <v-card-title class="headline">
                        <v-layout row justify-space-between>
                            <v-flex md11 class="ma-2 white--text">
                                {{blockTitle}}
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                </v-card>
            </div>
            <v-card-text>
                <slot name="block-elements">
                    <v-layout row justify-space-between>
                        <v-flex md11 class="ma-2">
                            <span
                                v-for="(hibauzenet, index) in this.$store.getters.hiba"
                                :key="index"
                                class="hibatext-color">
                                {{hibauzenet}}<br>
                            </span>
                        </v-flex>
                    </v-layout>
                </slot>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {

    props: {
        blockTitle: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped>
.card-wrapper {
    margin-top: 50px;
}
    .offset-header {
        top: -30px !important;
        margin: 0 auto;
        max-width: calc(100% - 32px);
    }
    .border-r-5 {
       /* border-radius: 5px;*/
    }
    .header-card {
        top: -30px !important;
        margin: 0 auto;
        max-width: calc(100% - 32px);
        min-height: 70px;
        color: white;
        /*font-weight: bold;*/
        font-size: 24px;
    }
    .card-header{
        transition: all ease-in-out 0.3s;
    }

    .headline {
        font-weight: 200 !important;
        font-size: 24px !important;
    }

    .hibatext-color {
      color: #DC1010;
      font-weight: bold;
    }

</style>
